import { ENV_DEV } from "../../../utils/window";

/**
 *
 * @param {OptionsListMapProps} options
 */
const checkPauseAndIterations = (options) => {
  const direction = /** @type {DefaultOptionMapProps} */ (
    options.get("direction")
  );
  const pause = /** @type {DefaultOptionMapProps} */ (options.get("pause"));
  const iterations = /** @type {DefaultOptionMapProps} */ (
    options.get("iterations")
  );

  if (iterations.get("is-default")) {
    if (ENV_DEV && !pause.get("is-default")) {
      const original = pause.get("original");
      console.warn(
        `[TorusKit warn]: You have set the \`${original}\` without any iterations. Make sure to add at least one \`iteration\`option. Otherwise the \`pause\` has no effect.`
      );
    }

    if (ENV_DEV && !direction.get("is-default")) {
      const original = direction.get("original");
      console.warn(
        `[TorusKit warn]: You have set the \`${original}\` direction without any iterations. Make sure to add at least one \`<iteration>\` option. Otherwise the \`direction: alternate\` has no effect.`
      );
    }
  }
};

export default checkPauseAndIterations;
